define.alias("shared/components/shared/social/refresh-profile/snapchat", "media/components/shared/social/refresh-profile/snapchat");